import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, query, where, orderBy, onSnapshot, arrayUnion, getDoc } from 'firebase/firestore'
import { db } from '../firebase'

// Events
export const addEvent = async (eventData, userId) => {
  const docRef = await addDoc(collection(db, 'events'), {
    ...eventData,
    organizer: userId,
    createdBy: userId,
    invited: [userId],
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateEventFirestore = async (eventId, updates) => {
  await updateDoc(doc(db, 'events', eventId), updates)
}

export const deleteEventFirestore = async (eventId) => {
  await deleteDoc(doc(db, 'events', eventId))
}

export const getEventFirestore = async (eventId) => {
  const docSnap = await getDoc(doc(db, 'events', eventId))
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() }
  }
  return null
}

export const subscribeToUserEvents = (userId, callback) => {
  const q = query(
    collection(db, 'events'),
    where('invited', 'array-contains', userId)
  )

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const events = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(events)
  })

  return unsubscribe
}

// Meals
export const addMealFirestore = async (eventId, mealData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/meals`), {
    ...mealData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateMealFirestore = async (eventId, mealId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/meals/${mealId}`), updates)
}

export const deleteMealFirestore = async (eventId, mealId) => {
  await deleteDoc(doc(db, `events/${eventId}/meals/${mealId}`))
}

export const subscribeToMeals = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/meals`), (snapshot) => {
    const meals = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(meals)
  })
  return unsubscribe
}

// Tasks
export const addTaskFirestore = async (eventId, taskData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/tasks`), {
    ...taskData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateTaskFirestore = async (eventId, taskId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/tasks/${taskId}`), updates)
}

export const deleteTaskFirestore = async (eventId, taskId) => {
  await deleteDoc(doc(db, `events/${eventId}/tasks/${taskId}`))
}

export const subscribeToTasks = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/tasks`), (snapshot) => {
    const tasks = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(tasks)
  })
  return unsubscribe
}

// Guests
export const addGuestFirestore = async (eventId, guestData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/guests`), {
    ...guestData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateGuestFirestore = async (eventId, guestId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/guests/${guestId}`), updates)
}

export const deleteGuestFirestore = async (eventId, guestId) => {
  await deleteDoc(doc(db, `events/${eventId}/guests/${guestId}`))
}

export const subscribeToGuests = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/guests`), (snapshot) => {
    const guests = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(guests)
  })
  return unsubscribe
}

// Shopping
export const addShoppingItemFirestore = async (eventId, itemData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/shopping`), {
    ...itemData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateShoppingItemFirestore = async (eventId, itemId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/shopping/${itemId}`), updates)
}

export const deleteShoppingItemFirestore = async (eventId, itemId) => {
  await deleteDoc(doc(db, `events/${eventId}/shopping/${itemId}`))
}

export const subscribeToShopping = (eventId, callback) => {
  const q = query(
    collection(db, `events/${eventId}/shopping`),
    orderBy('createdAt', 'desc')
  )
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Budget
export const addBudgetItemFirestore = async (eventId, itemData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/budget`), {
    ...itemData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateBudgetItemFirestore = async (eventId, itemId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/budget/${itemId}`), updates)
}

export const deleteBudgetItemFirestore = async (eventId, itemId) => {
  await deleteDoc(doc(db, `events/${eventId}/budget/${itemId}`))
}

export const subscribeToBudget = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/budget`), (snapshot) => {
    const budgetItems = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(budgetItems)
  })
  return unsubscribe
}

// Invitations
export const sendInvitationFirestore = async (data) => {
  await addDoc(collection(db, 'invitations'), {
    ...data,
    createdAt: new Date(),
  })
}

export const subscribeToUserInvitations = (email, callback) => {
  const q = query(
    collection(db, 'invitations'),
    where('toEmail', '==', email)
  )
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const invitations = snapshot.docs
      .map(doc => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(inv => inv.status === 'pending')
    callback(invitations)
  })
  return unsubscribe
}

export const updateInvitationFirestore = async (invId, updates) => {
  await updateDoc(doc(db, 'invitations', invId), updates)
}

// Inventar
export const addInventarItemFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/inventar`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateInventarItemFirestore = async (eventId, itemId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/inventar/${itemId}`), updates)
}

export const deleteInventarItemFirestore = async (eventId, itemId) => {
  await deleteDoc(doc(db, `events/${eventId}/inventar/${itemId}`))
}

export const subscribeToInventar = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/inventar`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Catering
export const addCateringFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/catering`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateCateringFirestore = async (eventId, id, updates) => {
  await updateDoc(doc(db, `events/${eventId}/catering/${id}`), updates)
}

export const deleteCateringFirestore = async (eventId, id) => {
  await deleteDoc(doc(db, `events/${eventId}/catering/${id}`))
}

export const subscribeToCatering = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/catering`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Restaurants
export const addRestaurantFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/restaurants`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateRestaurantFirestore = async (eventId, id, updates) => {
  await updateDoc(doc(db, `events/${eventId}/restaurants/${id}`), updates)
}

export const deleteRestaurantFirestore = async (eventId, id) => {
  await deleteDoc(doc(db, `events/${eventId}/restaurants/${id}`))
}

export const subscribeToRestaurants = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/restaurants`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Musik
export const addMusikFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/musik`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateMusikFirestore = async (eventId, id, updates) => {
  await updateDoc(doc(db, `events/${eventId}/musik/${id}`), updates)
}

export const deleteMusikFirestore = async (eventId, id) => {
  await deleteDoc(doc(db, `events/${eventId}/musik/${id}`))
}

export const subscribeToMusik = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/musik`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Transport
export const addTransportFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/transport`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateTransportFirestore = async (eventId, id, updates) => {
  await updateDoc(doc(db, `events/${eventId}/transport/${id}`), updates)
}

export const deleteTransportFirestore = async (eventId, id) => {
  await deleteDoc(doc(db, `events/${eventId}/transport/${id}`))
}

export const subscribeToTransport = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/transport`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Venues
export const addVenueFirestore = async (eventId, data) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/venues`), {
    ...data,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateVenueFirestore = async (eventId, id, updates) => {
  await updateDoc(doc(db, `events/${eventId}/venues/${id}`), updates)
}

export const deleteVenueFirestore = async (eventId, id) => {
  await deleteDoc(doc(db, `events/${eventId}/venues/${id}`))
}

export const subscribeToVenues = (eventId, callback) => {
  const unsubscribe = onSnapshot(collection(db, `events/${eventId}/venues`), (snapshot) => {
    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(items)
  })
  return unsubscribe
}

// Files
export const addFileFirestore = async (eventId, fileData) => {
  const docRef = await addDoc(collection(db, `events/${eventId}/files`), {
    ...fileData,
    createdAt: new Date(),
  })
  return docRef.id
}

export const updateFileFirestore = async (eventId, fileId, updates) => {
  await updateDoc(doc(db, `events/${eventId}/files/${fileId}`), updates)
}

export const deleteFileFirestore = async (eventId, fileId) => {
  await deleteDoc(doc(db, `events/${eventId}/files/${fileId}`))
}

export const subscribeToFiles = (eventId, callback) => {
  const q = query(
    collection(db, `events/${eventId}/files`),
    orderBy('createdAt', 'desc')
  )
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const files = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }))
    callback(files)
  })
  return unsubscribe
}
